var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKoons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 106,
    viewBox: "0 0 86 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.7882 33.9111C76.0155 33.45 75.8267 32.8855 75.3633 32.6583C74.8999 32.4312 74.3332 32.6182 74.1059 33.0793C73.9627 33.3649 72.0618 37.1845 71.9186 37.47C71.6912 37.9311 71.88 38.4956 72.3435 38.7228C72.8069 38.9499 73.3736 38.7628 73.6009 38.3018C73.7441 38.0162 75.645 34.1966 75.7882 33.9111Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1379 60.0463C60.1181 59.3448 61.3 58.9124 62.5973 58.8547C66.1528 58.6913 69.1702 61.4493 69.3335 65.0048C69.5738 70.2419 72.8218 75.8827 73.9365 77.4394C76.0121 80.3319 75.3491 84.3679 72.447 86.4435C69.5546 88.5191 64.6634 87.5435 62.5877 84.6415C61.915 83.7093 56.8893 75.5367 56.4376 65.5909C56.3416 63.3231 57.4178 61.2763 59.1379 60.0463Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5487 58.2154C61.1078 57.6389 58.0905 55.1692 59.7049 47.1645C61.0615 40.4379 65.5595 35.7646 71.2362 37.0746C77.0019 38.516 76.2332 45.2426 75.08 49.0864C73.6386 53.8912 68.7378 59.4454 63.5487 58.2154Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.199 57.74C69.4969 58.9412 69.4681 60.2289 69.0453 61.4781C67.8825 64.9183 64.6082 65.8168 60.6658 65.4225C55.8611 64.942 49.3651 64.6204 47.4912 65.0816C44.0222 65.9369 40.4955 63.7555 39.6307 60.2C38.7658 56.6445 40.8703 53.089 44.3393 52.2338C45.4636 51.9551 55.5536 49.6392 65.0189 53.041C67.1714 53.829 68.6801 55.6355 69.199 57.74Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0969 33.2551C28.8489 32.938 23.112 30.747 24.3901 19.4559C25.6009 8.80857 29.0891 1.78405 35.4121 2.00507C42.3694 2.25492 43.8012 9.99054 43.1862 18.0721C42.5712 26.1537 38.9965 33.9277 32.0969 33.2551Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3238 57.913C40.0631 58.0667 41.7832 58.7202 43.2631 59.8829C47.3279 63.0829 48.039 68.9735 44.839 73.0479C40.1304 79.0346 38.3526 88.3174 38.1028 91.1041C37.6319 96.2548 33.077 100.06 27.9264 99.5893C22.7757 99.1184 19.4028 94.3233 19.4412 89.4128C19.4508 87.7408 19.3451 77.4344 26.5522 67.3444C29.9841 62.5397 35.268 57.6439 38.3238 57.913Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6884 104C37.7761 104 35.8349 103.462 34.1052 102.347C29.3485 99.2625 28.3146 93.7705 31.0879 88.154C34.7202 80.7977 36.25 73.1101 36.6518 67.8011C37.1226 61.5787 41.2451 57.5382 46.9147 57.5382C52.5843 57.5382 57.1776 62.1315 57.1776 67.8011C57.1776 69.6269 56.9277 86.0495 48.2984 99.3298C46.3381 102.347 43.0517 104 39.6884 104Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.325 36.2052C39.1118 35.3211 44.6372 34.9848 47.8276 43.9408C50.845 52.3875 50.6239 58.8931 45.3579 60.9015C39.5634 63.1213 35.4794 57.7784 32.9425 51.4746C30.4152 45.1804 30.4152 38.0886 36.325 36.2052Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6522 28.9885C5.20955 25.7501 7.86178 20.2054 19.3835 22.6558C30.2518 24.9621 37.2283 29.1903 36.546 35.5229C35.7965 42.4898 27.7438 43.1336 19.47 41.6922C11.1963 40.2508 3.47984 35.8592 4.6522 28.9885Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2931 37.3679C37.8721 36.8586 31.9239 34.216 33.9034 22.3387C35.7773 11.1341 39.8613 3.88853 46.5399 4.48432C53.8911 5.13776 54.977 13.4019 53.8719 21.9255C52.7668 30.4395 48.5675 38.4634 41.2931 37.3679Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6247 89.7537C79.4812 90.4072 78.1455 90.7531 76.7425 90.6762C72.8603 90.4648 70.0927 88.0189 70.0927 83.2673C70.0927 77.2708 67.3925 71.1882 66.4315 69.2663C64.5096 65.4225 65.6532 61.5883 69.0165 59.6472C72.3894 57.7061 76.6944 58.8689 78.6356 62.2322C79.2602 63.3181 84.7376 73.1678 84.1514 84.0169C84.0169 86.4961 82.6235 88.6006 80.6247 89.7537Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80325 27.463C6.48452 25.5817 6.18725 23.7489 5.13928 23.3694C4.09131 22.9899 2.68949 24.2074 2.00822 26.0888C1.32695 27.9701 1.6242 29.8029 2.67217 30.1824C3.72014 30.5619 5.12197 29.3444 5.80325 27.463Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoons);
export default __webpack_public_path__ + "static/media/Koons.35c60336.svg";
export { ForwardRef as ReactComponent };var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKoons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 106,
    viewBox: "0 0 86 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.7882 33.9111C76.0155 33.45 75.8267 32.8855 75.3633 32.6583C74.8999 32.4312 74.3332 32.6182 74.1059 33.0793C73.9627 33.3649 72.0618 37.1845 71.9186 37.47C71.6912 37.9311 71.88 38.4956 72.3435 38.7228C72.8069 38.9499 73.3736 38.7628 73.6009 38.3018C73.7441 38.0162 75.645 34.1966 75.7882 33.9111Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1379 60.0463C60.1181 59.3448 61.3 58.9124 62.5973 58.8547C66.1528 58.6913 69.1702 61.4493 69.3335 65.0048C69.5738 70.2419 72.8218 75.8827 73.9365 77.4394C76.0121 80.3319 75.3491 84.3679 72.447 86.4435C69.5546 88.5191 64.6634 87.5435 62.5877 84.6415C61.915 83.7093 56.8893 75.5367 56.4376 65.5909C56.3416 63.3231 57.4178 61.2763 59.1379 60.0463Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5487 58.2154C61.1078 57.6389 58.0905 55.1692 59.7049 47.1645C61.0615 40.4379 65.5595 35.7646 71.2362 37.0746C77.0019 38.516 76.2332 45.2426 75.08 49.0864C73.6386 53.8912 68.7378 59.4454 63.5487 58.2154Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.199 57.74C69.4969 58.9412 69.4681 60.2289 69.0453 61.4781C67.8825 64.9183 64.6082 65.8168 60.6658 65.4225C55.8611 64.942 49.3651 64.6204 47.4912 65.0816C44.0222 65.9369 40.4955 63.7555 39.6307 60.2C38.7658 56.6445 40.8703 53.089 44.3393 52.2338C45.4636 51.9551 55.5536 49.6392 65.0189 53.041C67.1714 53.829 68.6801 55.6355 69.199 57.74Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0969 33.2551C28.8489 32.938 23.112 30.747 24.3901 19.4559C25.6009 8.80857 29.0891 1.78405 35.4121 2.00507C42.3694 2.25492 43.8012 9.99054 43.1862 18.0721C42.5712 26.1537 38.9965 33.9277 32.0969 33.2551Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3238 57.913C40.0631 58.0667 41.7832 58.7202 43.2631 59.8829C47.3279 63.0829 48.039 68.9735 44.839 73.0479C40.1304 79.0346 38.3526 88.3174 38.1028 91.1041C37.6319 96.2548 33.077 100.06 27.9264 99.5893C22.7757 99.1184 19.4028 94.3233 19.4412 89.4128C19.4508 87.7408 19.3451 77.4344 26.5522 67.3444C29.9841 62.5397 35.268 57.6439 38.3238 57.913Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6884 104C37.7761 104 35.8349 103.462 34.1052 102.347C29.3485 99.2625 28.3146 93.7705 31.0879 88.154C34.7202 80.7977 36.25 73.1101 36.6518 67.8011C37.1226 61.5787 41.2451 57.5382 46.9147 57.5382C52.5843 57.5382 57.1776 62.1315 57.1776 67.8011C57.1776 69.6269 56.9277 86.0495 48.2984 99.3298C46.3381 102.347 43.0517 104 39.6884 104Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.325 36.2052C39.1118 35.3211 44.6372 34.9848 47.8276 43.9408C50.845 52.3875 50.6239 58.8931 45.3579 60.9015C39.5634 63.1213 35.4794 57.7784 32.9425 51.4746C30.4152 45.1804 30.4152 38.0886 36.325 36.2052Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6522 28.9885C5.20955 25.7501 7.86178 20.2054 19.3835 22.6558C30.2518 24.9621 37.2283 29.1903 36.546 35.5229C35.7965 42.4898 27.7438 43.1336 19.47 41.6922C11.1963 40.2508 3.47984 35.8592 4.6522 28.9885Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2931 37.3679C37.8721 36.8586 31.9239 34.216 33.9034 22.3387C35.7773 11.1341 39.8613 3.88853 46.5399 4.48432C53.8911 5.13776 54.977 13.4019 53.8719 21.9255C52.7668 30.4395 48.5675 38.4634 41.2931 37.3679Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6247 89.7537C79.4812 90.4072 78.1455 90.7531 76.7425 90.6762C72.8603 90.4648 70.0927 88.0189 70.0927 83.2673C70.0927 77.2708 67.3925 71.1882 66.4315 69.2663C64.5096 65.4225 65.6532 61.5883 69.0165 59.6472C72.3894 57.7061 76.6944 58.8689 78.6356 62.2322C79.2602 63.3181 84.7376 73.1678 84.1514 84.0169C84.0169 86.4961 82.6235 88.6006 80.6247 89.7537Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80325 27.463C6.48452 25.5817 6.18725 23.7489 5.13928 23.3694C4.09131 22.9899 2.68949 24.2074 2.00822 26.0888C1.32695 27.9701 1.6242 29.8029 2.67217 30.1824C3.72014 30.5619 5.12197 29.3444 5.80325 27.463Z",
    fill: "#F2F2F2",
    stroke: "#909090",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoons);
export default __webpack_public_path__ + "static/media/Koons.35c60336.svg";
export { ForwardRef as ReactComponent };